<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <usuarios-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Actions -->
          <template #cell(id)="{ item, field: { key }, index }">
              <span>{{index + 1}}</span>
            </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              @click.prevent="edit(data.item)"
              v-b-tooltip.hover.top="'Editar'"
              variant="flat-success"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button @click.prevent="deleteAction(data.item)" size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import usuariosFilters from './usuariosFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UserService from '@/services/UserService'
import StoreService from '@/services/StoresService'
import RolesService from '@/services/RolesService'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      roles: [],
      fields: [
        //{ key: 'id', label: 'Nº', sortable: false },
        { key: 'email', label: 'Email', sortable: false },
        { key: 'fullname', label: 'Nombre', sortable: false },
        { key: 'document', label: 'Documento', sortable: false},
        { key: 'role.name', label: 'Rol', sortable: false },
        { key:'establishment.name', label: 'Local', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      form: {
        id: null,
        email: '',
        fullname: '',
        stores: [],
      },
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    usuariosFilters
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
      this.getData()
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async edit(item) {
      console.log('ITEM A EDITAR: ', item)
      const resp = await UserService.getUser(item.id, this.$store);
      const url = `?limit=1000&page=1&order=asc&sort=id`;
      const allStores = await StoreService.getStores(url, this.$store);
      if (resp && resp.data) {
        if (!this.roles || this.roles.length === 0) {
          const rolesResp = await RolesService.getRoles('', this.$store);
          if (rolesResp && rolesResp.data && rolesResp.data.rows) {
            this.roles = rolesResp.data.rows;
          }
        }
        const selectedRole = this.roles.find(role => role.id === resp.data.roleId);
        console.log('Respuesta del servicio:', resp.data);
        if (resp.data.userEstablishments && resp.data.userEstablishments.length > 0) {
          this.form.stores = [];
          resp.data.userEstablishments.forEach((establishment) => {
            const store = allStores.data.rows.find(s => s.id === establishment.establishmentId);
            if (store) {
              this.form.stores.push(store);
            }
          });

          this.form.establishmentsIds = this.form.stores.map(store => store.id);

          const defaultStore = allStores.data.rows.find(s => s.id === resp.data.establishmentDefault);
          this.form.establishmentDefault = defaultStore || null;
        } else {
          console.warn('userEstablishments está vacío o no existe');
        }
        this.form.id = resp.data.id;
        this.form.fullname = resp.data.fullname;
        this.form.email = resp.data.email;
        this.form.roleId = selectedRole ? selectedRole.id : null;;
        this.form.document = resp.data.document;
        this.form.extraPassword = resp.data.extraPassword;
        this.$refs.filters.isAdd = true;
        this.$nextTick(() => {
          if (this.$refs.filters.$refs.userAdd && typeof this.$refs.filters.$refs.userAdd.setData === 'function') {
            this.$refs.filters.$refs.userAdd.setData(this.form);
          } else {
            console.error('No se pudo acceder a setData en el componente usuariosAdd desde usuariosFilters');
          }
        });
      } else {
        console.error('La respuesta no tiene la estructura esperada', resp);}
    },
    async getData() {
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      console.log('url: ', url)
      const resp = await UserService.getUsers(url, this.$store)
      console.log('resp usuarios', resp)
      if (resp.data.rows.length != 0) {
        this.records = resp.data.rows
        this.totalElements = resp.data.rows.length
      }
      this.showLoading = false
    },
    async deleteAction(data) {
      this.$swal({
        title: '¿Desea eliminar este usuario?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminalo',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1
          this.$swal({
            icon: 'success',
            title: 'Eliminado!',
            text: 'El usuario ha sido eliminado.',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
          this.deleteData(data.id)
        }
      })
    },
    async deleteData(id) {
      console.log('id del postu', id)
      const resp = await UserService.deleteUser(id, this.$store)
      console.log('resp delete', resp)
      if (resp) {
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al eliminar el usuario.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
      console.log('respDelete', resp)
    }
  }
}
</script>

<style></style>
